// GTM event tracking utility
export const trackEvent = (eventName, eventData = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData
    });
  }
};

// Predefined event names
export const GTM_EVENTS = {
  PAGE_VIEW: 'page_view',
  FILE_UPLOAD: 'file_upload',
  FILE_SAVE: 'file_save',
  FILE_EXPORT: 'file_export',
  COLOR_MODIFY: 'color_modify',
  ELEMENT_DELETE: 'element_delete',
  GOOGLE_DRIVE_OPEN: 'google_drive_open',
  GOOGLE_DRIVE_SAVE: 'google_drive_save',
  ERROR_OCCURRED: 'error_occurred'
}; 